export enum MissionNextLevelTypeEnum {
  ANY = 'any',
  SPECIFIC_LEVEL = 'specific_level',
}
